import { PropsWithChildren, useEffect } from "react";
import { signIn, signOut } from "next-auth/react";
import { useSessionKf } from "components/auth/lib/useSessionKf";
import LoadingFullScreen from "components/elements/Loading/LoadingFullScreen";

export default function AuthGuard({ children }: PropsWithChildren) {
  const { session, status } = useSessionKf();

  const isAuthenticated = !!session?.user;
  const isLoading = status === "loading";

  useEffect(() => {
    if (!isAuthenticated && !isLoading) signIn();
  }, [isAuthenticated, isLoading]);

  useEffect(() => {
    if (session?.error === "RefreshAccessTokenError" && !isLoading) signOut();
  }, [session?.error, isLoading]);

  if (!isAuthenticated) return <LoadingFullScreen />;

  return <>{children}</>;
}
